export function setAffiliateId() {
    const params = new URLSearchParams(window.location.search)
    
    const id = params.get('ref')
    if (id) {
        localStorage.setItem('ref', JSON.stringify({ id, dt: (Date.now() / 1000).toFixed(0) }))
        return
    }
    
    const id2 = params.get('refId')
    const dt2 = params.get('refDt')
    
    if (id2 && dt2) {
        localStorage.setItem('ref', JSON.stringify({ id: id2, dt: dt2 }))
        return
    }
}

export function getAffiliateId(): { id: string; dt: string } | null {
    const ref = localStorage.getItem('ref')
    if (ref) {
        return JSON.parse(ref)
    }
    return null
}


